import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export const useReCaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { isAuthenticated } = useAuth0();

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha || isAuthenticated) {
      return;
    }

    return await executeRecaptcha();
  }, [executeRecaptcha, isAuthenticated]);

  return {
    handleReCaptchaVerify
  };
};
